import React from 'react';
import { Box, BoxProps, FuseSelect, dataModelIcons } from '/src/components';
import { Lender, TLenderId } from '/src/lib/models';
import { DataModelType } from '/src/lib/types';

export type LenderSelectProps = {
  /**
   * Selected Lender ID
   */
  value: TLenderId;
  /**
   * Sets the currently selected Lender ID
   * @param value TLenderId
   * @returns void
   */
  setValue: (value: TLenderId) => void;
  /**
   * List of Lenders to display in the dropdown
   */
  lenders: Lender[];
  /**
   * Optional Box component props
   */
  boxProps?: BoxProps;
  /**
   * Show a label for this component
   */
  showLabel?: boolean;
  /**
   * Element ID
   */
  id?: string;
  /**
   * Element name
   */
  name?: string;
  /**
   * Element class
   */
  className?: string;
  /**
   * Whether this component is disabled
   */
  disabled?: boolean;
  /**
   * If true, shows error if value is empty
   */
  required?: boolean;
  /**
   * Error to display if `required` is set to true
   */
  error?: string;
  /**
   * Text to display if no value is set
   */
  placeholder?: string;
  /**
   * Label for screen readers
   */
  ariaLabel?: string;
  /**
   * Whether to enable the placeholder as a selectable option
   */
  enablePlaceholderOption?: boolean;
};

export const LenderSelect: React.FC<LenderSelectProps> = ({
  value,
  setValue,
  lenders,
  boxProps,
  placeholder = 'Select Investor',
  ariaLabel = 'Select Investor',
  ...selectProps
}) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap="6px" {...boxProps}>
      <Box component="span">{dataModelIcons[DataModelType.Lender]}</Box>
      <FuseSelect
        value={value}
        updateValue={(value) => setValue(value)}
        placeholder={placeholder}
        ariaLabel={ariaLabel}
        options={lenders.map((company) => ({ label: company.name, value: company._id }))}
        {...selectProps}
      />
    </Box>
  );
};
